import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  LightpathSubscriptionDetailsGQL,
  LightpathSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { LightPathSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { LightpathSubscriptionView } from "./lightpath-subscription-view";

@Component({
  selector: "lightpath-subscription",
  templateUrl: "lightpath-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LightpathSubscriptionView, SubscriptionPageComponent],
})
export class LightpathSubscriptionComponent extends GenericSubscription<
  LightpathSubscriptionDetailsQuery,
  LightPathSubscriptionDetails
> {
  protected query = inject(LightpathSubscriptionDetailsGQL);

  protected onQuerySuccess(data: LightpathSubscriptionDetailsQuery): LightPathSubscriptionDetails {
    return data.lpDetails;
  }
}
